import { createGlobalStyle } from 'styled-components';

import { MainPage } from './main-page';

const GlobalStyle = createGlobalStyle`
  body {
    overflow-x: hidden;
  }
`;

export const Component: React.FC = () => (
  <>
    <GlobalStyle />
    <MainPage />
  </>
);
